"use strict";

// this file is import from webpack config use es5 export and require
// do not change it
const lodash = require('lodash');

const ColorUtils = require('./color-utils');

const CAPTION_FLDS = require('../config/caption-inputs');

const OUTRO_FLDS = require('../config/outro-inputs');

const formatInputsAsArray = require('./inputs-utils');

const inputsTextTypes = {
  'text': 1,
  'url': 1,
  'tel': 1,
  'date': 1,
  'time': 1
};

function getFontId(f) {
  return `${lodash.kebabCase(f.font + f.weights[0])}`;
}

function defaultDataFromList(list, supportOldJson) {
  const obj = {};
  list.forEach(item => {
    const inputs = formatInputsAsArray(item.inputs, CAPTION_FLDS, OUTRO_FLDS, supportOldJson);
    const colorInputs = inputs.filter(input => input.type === 'color');
    const normalizedColors = lodash.merge(ColorUtils.normalizeColorsObject(colorInputs), ColorUtils.normalizeColorsObject(item.colors));
    obj[item.name] = {
      defaultFont: lodash.isArray(item.fonts) && item.fonts.length && getFontId(item.fonts[0]),
      colors: normalizedColors,
      excludeFonts: item.excludeFonts ? item.excludeFonts.map(f => getFontId(f)) : [],
      inputs: supportOldJson ? inputs : inputs.filter(input => inputsTextTypes[input.type]),
      // when inputs was not define set default input
      media: inputs.filter(input => input.type === 'image')
    };
  });
  return obj;
}

module.exports = defaultDataFromList;